import React from "react";
import { func, string } from "prop-types";
import cx from "classnames";

import { Bar, BarItem, Button, Icon } from "..";

import { ModalContext } from "./Modal";

const propTypes = {
  /** Custom title renderer. Passes default props as function parameter. */
  renderCloseButton: func,
  /** Custom title renderer. Passes default props as function parameter. */
  renderTitle: func,
  /** Modal title */
  title: string,
};

const CLASS_ROOT = "modal-dialog__header";

const ModalHeader = ({
  className,
  children,
  title,
  renderTitle,
  renderCloseButton,
  ...other
}) => {
  const classes = cx(CLASS_ROOT, className);
  const cardTitle = (titleId) =>
    renderTitle ? renderTitle({ id: titleId }) : <h2 id={titleId}>{title}</h2>;

  const closeButtonProps = {
    className: "modal-dialog__close",
    "data-a11y-dialog-hide": true,
    "aria-label": "Close the dialog",
    disabled: true,
  };

  const closeButton = renderCloseButton ? (
    renderCloseButton(closeButtonProps)
  ) : (
    <Button
      className="modal-dialog__close"
      type="link"
      equal
      {...closeButtonProps}
    >
      <Icon size="medium" name="close" />
    </Button>
  );

  const headerBar = (titleId) => (
    <Bar>
      <BarItem isFilling>{cardTitle(titleId)}</BarItem>
      {closeButton && <BarItem>{closeButton}</BarItem>}
    </Bar>
  );

  return (
    <ModalContext.Consumer>
      {({ titleId }) => (
        <div className={classes} {...other}>
          {headerBar(titleId)}
          {children}
        </div>
      )}
    </ModalContext.Consumer>
  );
};

ModalHeader.displayName = "ModalHeader";
ModalHeader.propTypes = propTypes;

export default ModalHeader;
